import { http } from "../_apiConfig/http";
import { RouteUrls } from "../_apiConfig/routeUrls";

export const SiteService = {
  createSite,
  updateSite,
  getSiteList,
  getSingleSite,
  deleteSite,
  getSitesByOrganization,
};

// CREATE SITE
function createSite(data) {
  return http.post(`${RouteUrls.Site}`, data, true);
}

// UPDATE SITE
function updateSite(siteId, data) {
  return http.update(`${RouteUrls.Site}/${siteId}`, data, true);
}

// GET ALL SITES
function getSiteList(queryParams = "") {
  return http.get(`${RouteUrls.Site}${queryParams}`, true);
}

// GET SINGLE SITE DETAILS
function getSingleSite(siteId) {
  return http.get(`${RouteUrls.Site}/${siteId}`, true);
}

// DELETE SITE
function deleteSite(siteId) {
  return http.remove(`${RouteUrls.Site}/${siteId}`, true);
}

// GET ALL SITES BY ORGANIZATION
function getSitesByOrganization(
  organization_id,
  params = { page: 1, limit: 20 }
) {
  return http.get(
    `${RouteUrls.Site}/organization/${organization_id}`,
    { params },
    true
  );
}


